module.exports = __webpack_public_path__ + "img/scene4copy01.6b599127.png";